import React from "react";

const DeleteHoraires = () => {
  return <div>Delete Horaires</div>;
};

export { DeleteHoraires };
